import React,{useState,useEffect} from 'react'
import './authStyles.css'
// import accountant from '../assets/g10.svg'
import accountant from "../assets/signIn.svg";
import Logo from '../assets/Logo-my.svg'
import { Form } from "react-bootstrap";
import ForgotPwd from './ForgotPwd';
import {Link} from 'react-router-dom'
import axios from 'axios'
import {GoogleLogin} from 'react-google-login'
import {Submit} from '../Components/Button'
import {useHistory} from 'react-router-dom'
import swal from 'sweetalert';
import signInCss from "../myfin_v2/css/signIn.module.css"
import commoncss from "../myfin_v2/css/common.module.css"
import buttoncss from "../myfin_v2/css/button.module.css"
import InputGroup from "../myfin_v2/elements/InputGroup";
import { ReactComponent as MyFinLogo } from "../myfin_v2/assets/icons/myfinLogo.svg"
import { ReactComponent as HideIcon } from "../myfin_v2/assets/icons/hide.svg"
import { ReactComponent as ShowIcon } from "../myfin_v2/assets/icons/show.svg"


const CreatePassword = ({ match: {params}}) => {
    let history = useHistory()
    const [error, seterror] = useState(false)
    const [password, setPassword] = useState('')
    const [confrmpwd ,setConfrmpwd] = useState('')
    const [ShowPwd, setShowPwd] = useState(false)
    const [ShowCmpwd, setShowCmpwd] = useState(false)

    const { id } = params;

    // function handleChange(e){
    //     setValue({...Value,[e.target.name]:e.target.value})
    //     console.log(Value,error,'values and errors')
    // }
    
    // function validation(){
        
    //     const err = (Value.NewPassword === Value.RetypePassword | Value.RetypePassword.length === 0 ? false : true)
    //     seterror(err)
        
    // }
    
    // useEffect(() => {
    //     validation()
        
    // },[Value])
    
    
    // const responseGoogle = (res) => {
    //     console.log(res,'response from google')
    // };

    async function handleSignUp(){

        const fd = {
            password:password,
            confrmpwd:confrmpwd,
            userId:id
        }
        console.log(fd);
        if(!fd.password && !fd.confrmpwd){
            return swal("All fields should be filled!")
        }
        if(fd.password.length < 6){
           return swal("You should create password with atleast 7 characters")
        }

        if(fd.password === fd.confrmpwd){

          await  axios.post('api/v1/superadmin/createpassword',fd)
            .then(res =>{
                console.log(res,'api call')
                setPassword('')
                setConfrmpwd('')
                swal("Your Password Created Successfully,Now you can login with new password! Go to Signin").then(() => {
                    history.push("/");
                });
            })
            .catch(err=>{
                console.log(err.response)
                // swal(err.response)
                // swal(err.response.data.error)
                swal("", err.response.data.error , "error");
      
            })

        }
        else{
             
            swal("Password and Confirm password not match!Try again carefully")
            return (
                setConfrmpwd('')
            )
        }
    }

    return (
        <div className="conatiner">

            <div className={signInCss.imgContainer}>
                <img src={accountant} alt="accountant working" style={{
                "height": "93.7vh", "place-self": "center"
                }}></img>
            </div>
            <div className={signInCss.formContainer}>
                <div
                className={commoncss.dFlexJustifysb}

                >
                <div className={commoncss.dFlex}>
                    <div className={commoncss.dFlexClm}>
                    <span className={signInCss.heading1}>
                        Hello there!
                    </span>
                    <span className={signInCss.label1}>
                        Password Reset in Progress
                    </span>
                    </div>
                </div>
                <div>
                    <MyFinLogo />
                </div>
                </div>
                <div className={signInCss.container2}>
                
                    <div className={`${signInCss.container3} mt-2`}>
                        <label className={signInCss.headerText}>Create New Password</label>
                        <form
                            onSubmit={(e) => {
                                console.log("submit");
                                e.preventDefault();
                            }}
                        >
                        <InputGroup
                            class_="mt-4"
                            label="New Password"
                            inputs={[
                            <>
                                <input
                                    id="fname"
                                    value={password}
                                    type={!ShowPwd? "password" :"text"}
                                    onChange={event => setPassword(event.target.value)}
                                    placeholder="Enter Password"
                                    name="NewPassword"
                                />
                                <span className="icon" style={{ cursor: "pointer", pointerEvents: "auto" }} onClick={()=>setShowPwd(!ShowPwd)}>
                                    {ShowPwd ? <ShowIcon height={18} /> : <HideIcon height={18} /> }
                                </span>
                            </>,
                            ]}
                        />

                        <InputGroup
                            class_="mt-2"
                            label="Re-Type Password"
                            inputs={[
                            <>
                                <input
                                    onChange={event => setConfrmpwd(event.target.value)}
                                    value={confrmpwd}
                                    name="RetypePassword"
                                    placeholder="Re-Type password"
                                    type={!ShowCmpwd? "password" :"text"}
                                />
                                <span className="icon" style={{ cursor: "pointer", pointerEvents: "auto" }} onClick={()=>setShowCmpwd(!ShowCmpwd)}>
                                    {ShowCmpwd ? <ShowIcon height={18} /> : <HideIcon height={18} /> }
                                </span>
                            </>,
                            ]}
                        />
                        <div className="w-100 mt-4">
                            <button type="submit" onClick={()=>handleSignUp()} className={buttoncss.primary} value="Sign in" style={{ "padding": "7px", "width": "100%", "border-radius": "12px" }}>Set Password</button>
                        </div>
                        </form>
                    </div>
                    <div
                        className={`w-100 ${signInCss.tnc}`}
                    >
                        <span>
                        <span className={signInCss.label1}>By joining, you agree to the</span><span className={signInCss.label2}>Terms and Privacy Policy</span>
                        </span>
                    </div>
                </div>
            </div>
            </div>
        );
    // return (
    //     <div className='conatiner'>
    //         <div className="column-1">
    //             <div className="logo" style={{display:'flex'}}><img src={Logo}></img></div>
    //             <div className="pg-title" style={{display:'flex'}}><h1>Create Password</h1></div> 
    //             <div className="password-signin" style={{display:'flex',flexDirection:'column'}}>
    //                 <h3>Enter New Password</h3>
    //                     <input type="text" id="fname"  onChange={event => setPassword(event.target.value)} value={password} name="NewPassword" placeholder=""  type={!ShowPwd? "password" :"text"}/>
    //                     <i onClick={()=>setShowPwd(!ShowPwd)} class= {ShowPwd ? "fas fa-eye" : "far fa-eye-slash"} />
    //             </div>  
    //             <div className="password-signin" style={{display:'flex',flexDirection:'column'}}>
    //                 <h3>Retype Password</h3>
    //                     <input type="text" id="fname"  onChange={event => setConfrmpwd(event.target.value)} value={confrmpwd} name="RetypePassword" placeholder=""  type={!ShowCmpwd? "password" :"text"}/>
    //                     <i onClick={()=>setShowCmpwd(!ShowCmpwd)} class= {ShowCmpwd ? "fas fa-eye" : "far fa-eye-slash"} />
    //                     {error ? <p style={{color:'red',marginRight:'auto',fontSize:'15px'}}>password doesn't match</p> : null}

    //             </div>  
            
    //             <div className='submit' onClick={()=>handleSignUp()} >{error? <Submit  disable value="Create password"/> : <Submit   value="Create password"/> }</div>
            
    //         </div>
    //         <div className="column-2"><img src={accountant} alt='accountant working' ></img></div>
    //     </div>
    // )
}

export default CreatePassword
